<script lang="ts">
    // @check-js
    import { slide } from "svelte/transition";
    import Icon from "svelte-fa";
    import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
    import { cart } from "../../../stores/cart";
    import { cartPopupOpen } from "../../../stores/cart-popup-open.js";
    import MenuHider from "$lib/menu/MenuHider.svelte";
    import Button from "../../buttons/Button.svelte";
    import Hamburger from "./Hamburger.svelte";
    import { trackNavigationClickTypes, trackNavigationClick } from "../../../utils/track.utils.js";
    export let sidebar = false;
    let searchOpen = false;

    const closeSidebar = () => {
        sidebar = false;
        return true;
    };

    $: if ($cartPopupOpen) {
        setTimeout(() => cartPopupOpen.close(), 1000);
    }

    /**
     *
     * @param {HTMLInputElement} el
     */
    function focusSearch(el) {
        el.focus();
    }
</script>

<MenuHider --header-height="70px" active={!searchOpen && !$cartPopupOpen}>
    <header
        style="display: flex; flex-direction:row;"
        class="mx-0 justify-between items-center h-[50px] text-white px-5 w-screen"
    >
        <!-- MENU ######## -->
        <div class="flex w-1/3">
            <nav class="flex">
                <Hamburger bind:open={sidebar} />
            </nav>
        </div>

        <!-- LOGO ######## -->
        <div class="w-1/3 flex justify-center">
            <a
                href="/"
                on:click={() => {
                    closeSidebar();
                    trackNavigationClick(trackNavigationClickTypes.MOBILE_LOGO_CLICK, "Logo");
                }}
            >
                <img
                    src="/images/logo/nylanders-logo-desktop-white.png"
                    srcset="/images/logo/nylanders-logo-desktop-white.png 1x, /images/logo/nylanders-logo-desktop-white-2x.png 2x"
                    width="150"
                    height="37"
                    alt="Nylanders logotyp"
                />
            </a>
        </div>

        <div class="w-1/3 flex flex-row justify-between">
            <!-- SEARCH ######## -->
            <div class="flex w-1/2 justify-center shrink">
                <button aria-label="Toggla sökfältet" class="search" on:click={() => (searchOpen = !searchOpen)}>
                    {#if !searchOpen}
                        <svg
                            class="text-white h-5 w-5 fill-current"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            version="1.1"
                            id="Capa_1"
                            x="0px"
                            y="0px"
                            viewBox="0 0 56.966 56.966"
                            style="enable-background:new 0 0 56.966 56.966;"
                            xml:space="preserve"
                            width="512px"
                            height="512px"
                        >
                            <path
                                d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z"
                            />
                        </svg>
                    {:else}
                        <Icon icon={faArrowDown} />
                    {/if}
                </button>
            </div>

            <!-- CART ######## -->
            <div class="cart w-1/2 flex justify-center">
                <!-- svelte-ignore a11y-no-static-element-interactions a11y-click-events-have-key-events -->
                <div class="cart cursor-pointer" on:click={closeSidebar} title="Gå till kassan">
                    <a href="/kassa" class="flex fow-row" aria-label="Gå till kassan">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="file:h-6 w-6 shrink-0"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
                            />
                        </svg>
                        <div>
                            <p
                                class:items={$cart.products.length}
                                class:hidden={!$cart.products.length}
                                class="flex h-6 w-2 items-center justify-center rounded-full bg-red-500 p-3 text-xs text-white"
                            >
                                {$cart.products.length}
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </header>
    {#if searchOpen}
        <div transition:slide|global class="search-bar flex justify-center">
            <div class="w-full h-full flex-wrap">
                <form action="/sok-mattor/" method="GET" data-sveltekit-reload>
                    <input
                        use:focusSearch
                        name="s"
                        class="search-input w-2/3 mr-2"
                        type="search"
                        placeholder="Sök vårt stora sortiment"
                        aria-label="Sök vårt stora sortiment"
                        autocomplete="off"
                    />
                    <Button primary={true} type="submit">Sök</Button>
                </form>
            </div>
        </div>
    {/if}
</MenuHider>
<div style="padding-top:50px" />

<style>
    header {
        background: rgb(17, 17, 17);
        background: linear-gradient(270deg, rgba(17, 17, 17, 1) 0%, rgba(43, 43, 43, 1) 50%, rgba(17, 17, 17, 1) 100%);
    }
    .cart,
    .search {
        font-size: 1.2em;
    }

    .search-bar {
        height: 5.5em;
        width: 100%;
        background: rgb(77, 77, 77);
        text-align: center;
        padding-top: 12px;
    }
    .search-bar .search-input {
        font-size: 1.05em;
        height: 3em;
        border: 1px solid white;
        border-radius: 10px;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }
</style>
